import List from '../../containers/UserRequests/List';
import Edit from '../../containers/UserRequests/Edit';
import Create from '../../containers/UserRequests/Create';
import Show from '../../containers/UserRequests/Show';

export default { List, Edit, Create, Show };
